export default {
  namespaced: true,
  state: {
    selectedRow: false,
    ongoingAlteredRow: false,
    loading: false,
    detailsData: undefined
  },
  getters: {
    state: (state) => state
  },
  actions: {
    setLoading ({ commit }, loading) {
      commit('setLoading', loading)
    },
    setNullSelectedRow ({ commit }) {
      commit('setSelectedRow', false)
    },
    setSelectedRow ({ commit, state }, record) {
      console.log('clicked on ' + record.numero)
      // Si l'on reclic sur le même détail, on le ferme
      if (state.selectedRow) {
        if (state.selectedRow === record) {
          commit('setSelectedRow', false)
          return
        }
      }
      commit('setSelectedRow', record)
    },
    setDetailsData ({ commit }, detailsData) {
      commit('setDetailsData', detailsData)
    },
    setOngoingAlteredRow ({ commit }, ongoingAlteredRow) {
      commit('setOngoingAlteredRow', ongoingAlteredRow)
    }
  },
  mutations: {
    setLoading (state, loading) {
      state.loading = loading
    },
    setSelectedRow (state, record) {
      state.selectedRow = record
    },
    setDetailsData (state, detailsData) {
      state.detailsData = detailsData
    },
    setOngoingAlteredRow (state, ongoingAlteredRow) {
      state.ongoingAlteredRow = ongoingAlteredRow
    }
  }
}
